import { Size } from "@brightagency/headstart-common";
import React from "react";
import { useRegionSelectVisibility } from "../../../services/app-state";
import { useBreakpoint } from "../../../utils/hooks";
import { Modal } from "../../molecules/Modal";
import { RegionSelect } from "./RegionSelect";

export const RegionSelectModal = () => {
    const [isLocationSelectVisible, { setRegionSelectVisibility }] = useRegionSelectVisibility();
    const isLarge = useBreakpoint(Size.large);
    return (
        <Modal
            isVisible={isLocationSelectVisible}
            alignTopOnSmall
            maxWidth={1340}
            onClose={() => setRegionSelectVisibility(false)}
            hasCloseButton
            horizontalPadding={isLarge ? 30 : undefined}
        >
            <RegionSelect />
        </Modal>
    );
};
